import builder from '../builder';
import SocialMediaGoogle from '../../streamline-icons/light/social-media-google.svg';

export default builder('IconSocialMediaGoogleLight', SocialMediaGoogle);
